import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useThemeStore = defineStore('theme', () => {

    const theme = ref<'light' | 'dark'>('dark')

    if (localStorage.getItem('theme')) {
        theme.value = localStorage.getItem('theme') as 'light' | 'dark'
    }

    function toggleTheme() {
        theme.value = theme.value === 'light' ? 'dark' : 'light'
        //save to local storage
        localStorage.setItem('theme', theme.value)
    }

    function setTheme(newTheme) {
        theme.value = newTheme
        localStorage.setItem('theme', theme.value)

    }

    return { theme, toggleTheme, setTheme }
})
